import { useTranslation } from 'react-i18next';
import { GoogleFontIcon, SVGIcon } from '@asset-metrix/portal-ui';
import clsx from 'clsx';

import styles from './filters.module.scss';

export type FilterPersistenceMode =
  | 'autoSaveEnabled'
  | 'autoSaveDisabled'
  | 'autoSaveForceEnabled'
  | 'manualSave';

type FilterPersistenceIconProps = {
  mode: FilterPersistenceMode;
  onClick?: () => void;
};

const i18nKeys = {
  autoSaveEnabled: 'app.pageFilter.autoSaveEnabled',
  autoSaveDisabled: 'app.pageFilter.autoSaveDisabled',
  autoSaveForceEnabled: 'app.pageFilter.autoSaveForceEnabled',
  manualSave: 'app.pageFilter.manualSave',
} as const;

export function FilterPersistenceIcon({
  mode,
  onClick,
}: FilterPersistenceIconProps) {
  const { t } = useTranslation();
  const label = t(i18nKeys[mode]);
  const isClickable = mode !== 'autoSaveForceEnabled';
  const icon =
    mode === 'manualSave' ? (
      <GoogleFontIcon
        solid={true}
        small={true}
        name="save"
        className={styles['persistenceIcon__material']}
      />
    ) : (
      <SVGIcon
        name={mode === 'autoSaveDisabled' ? 'save-clock-off' : 'save-clock'}
      />
    );

  return (
    <span
      title={label}
      className={clsx(
        styles['persistenceIcon'],
        isClickable
          ? styles['persistenceIcon--clickable']
          : styles['persistenceIcon--disabled']
      )}
      onClick={isClickable ? onClick : undefined}
    >
      {icon}
    </span>
  );
}
